document.addEventListener('alpine:init', () => {
  Alpine.data('ThemeModule_CartDrawer', ({ openOnAddToCart }) => {
    return {
      init() {
        if (openOnAddToCart === true) {
          document.body.addEventListener(
            'switch:cart:afteradditem',
            () => {

              Object.keys(Alpine.store('modals').modals).forEach((modal) => {
                Alpine.store('modals').close(modal);
              });

              Alpine.store('modals').open('cart');
            }
          );
        }

        Alpine.store('modals').register('cart', 'rightDrawer');

        // When the Section Store cart drawer app is active, open it instead
        // of the theme's built-in cart drawer so there is only ever one cart.
        const modals = Alpine.store('modals');
        const themeOpen = modals.open.bind(modals);

        modals.open = (name) => {
          if (name === 'cart' && window.SectionStoreCart) {
            Object.keys(modals.modals).forEach((modal) => {
              modals.close(modal);
            });

            window.SectionStoreCart.open();
            return;
          }

          return themeOpen(name);
        };
      },
    };
  });
});

// Match the Section Store cart drawer typography to the product page:
// 14px regular for text, 10.5px regular for secondary text. The font family
// is already inherited from the theme.
const sectionStoreCartTag = 'section-store--cart-block';
const sectionStoreCartTypography = `
  .cart-title,
  .cart-empty-state h3,
  .cart-empty-state p,
  .cart-empty-continue,
  .cart-initial-loading,
  .cart-error,
  .cart-reward-text,
  .cart-products-upsell-title,
  .cart-products-upsell-product-title,
  .cart-products-upsell-price-row,
  .cart-products-upsell-price,
  .cart-products-upsell-button,
  .cart-products-upsell-variant-select,
  .cart-line-title,
  .cart-line-price,
  .cart-line-quantity-input,
  .cart-order-note-toggle,
  .cart-order-note-title,
  .cart-order-note textarea,
  .cart-footer-toast,
  .cart-order-upsell-title,
  .cart-order-upsell-price,
  .cart-discount-toggle,
  .cart-discount-title,
  .cart-discount-label,
  .cart-discount-row input,
  .cart-discount-row button,
  .cart-discount-total-row,
  .cart-subtotal-title,
  .cart-subtotal-prices,
  .cart-checkout-link {
    font-size: 14px !important;
    font-weight: 400 !important;
  }

  .cart-line-subtitle,
  .cart-line-selling-plan,
  .cart-line-properties,
  .cart-line-property-name,
  .cart-line-discounts,
  .cart-line-compare,
  .cart-products-upsell-subtitle,
  .cart-products-upsell-product-subtitle,
  .cart-order-upsell-subtitle,
  .cart-applied-discount,
  .cart-subtotal-compare,
  .cart-subtotal-subtitle {
    font-size: 10.5px !important;
    font-weight: 400 !important;
  }
`;

customElements.whenDefined(sectionStoreCartTag).then(() => {
  document.querySelectorAll(sectionStoreCartTag).forEach((cart) => {
    if (!cart.shadowRoot) return;
    if (cart.shadowRoot.querySelector('#theme-cart-typography')) return;

    const style = document.createElement('style');
    style.id = 'theme-cart-typography';
    style.textContent = sectionStoreCartTypography;
    cart.shadowRoot.appendChild(style);
  });
});
